import '@/woocommerce/variation-swatches.js';
import '@/woocommerce/single-product.js';
import '@/woocommerce/extension-shop-as-client.js';
import '@/woocommerce/extension-pewc.js';
import '@/woocommerce/extension-nuwoo-pa-options.js';
import '@/woocommerce/archive-product.js';


/**
 * Remove Woocommerce's horrendous scrolling on the cart page
 */
jQuery( document ).ajaxComplete( function( event, xhr, settings ) {
    if ( !document.body.classList.contains( 'woocommerce-cart' ) ) return;
    jQuery( 'html, body' ).stop();
} );
